import React, { useContext } from 'react';
import { IconType } from 'react-icons/lib';
import Skeleton from 'react-loading-skeleton';
import * as CTX from '../../../../context/globalContext';
import * as S from './styles';
import { toUpper } from 'lodash';

type ContainerWithInformationProps = {
  text: string;
  Icon: IconType;
  identifier?: string;
  identifierType?: 'cpf' | 'cnpj';
};

export const ContainerWithInformation: React.FC<
  ContainerWithInformationProps
> = ({ text, Icon, identifier, identifierType }) => {
  const globalContext = useContext(CTX.Context);

  return (
    <>
      <S.Up>
        <S.CardTitle>
          {globalContext.isLoading ? (
            <>
              <Skeleton
                circle={true}
                height={15}
                width={15}
                style={{ marginRight: '12px' }}
              />
              <Skeleton width="127px" />
            </>
          ) : (
            <>
              <Icon size={17} color={'#012d5c'} />
              {text}
            </>
          )}
        </S.CardTitle>
        {identifier && (
          <S.UserIdentifier>
            {globalContext.isLoading ? (
              ''
            ) : (
              <>
                {toUpper(identifierType)}: <span>{identifier}</span>
              </>
            )}
          </S.UserIdentifier>
        )}
      </S.Up>
    </>
  );
};
